import AwesomeDebouncePromise from 'awesome-debounce-promise';
import ApiService from '../services/apiService';

export const indexOtherRequestTypeRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_request_types', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const showOtherRequestTypeRequest = (id, { dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', `/other_request_types/${id}`, {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const createOtherRequestTypeRequest = ({ dispatch, params, formData, callback, successCallback }) =>
  ApiService.request('post', '/other_request_types', {
    dispatch,
    params,
    callback,
    formData,
    successCallback
  });

export const updateOtherRequestTypeRequest = (id, { dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('put', `/other_request_types/${id}`, {
    dispatch,
    params,
    formData,
    successCallback,
    failureCallback
  });

export const deleteOtherRequestTypeRequest = (id, { dispatch, failureCallback, successCallback, callback }) =>
  ApiService.request('delete', `/other_request_types/${id}`, {
    dispatch,
    failureCallback,
    successCallback,
    callback
  });

export const destroyMultipleOtherRequestTypeRequest = ({ dispatch, params, failureCallback, successCallback, callback }) =>
  ApiService.request('delete', '/other_request_types/destroy_multiple', {
    dispatch,
    params,
    formData: false,
    failureCallback,
    successCallback,
    callback
  });

export const updateStatusMultipleOtherRequestTypeRequest = ({ dispatch, params, failureCallback, successCallback, callback }) =>
  ApiService.request('put', '/other_request_types/update_status_multiple', {
    dispatch,
    params,
    failureCallback,
    successCallback,
    callback
  });

export const exportOtherRequestTypeRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_request_types/export.xlsx', {
    dispatch,
    params,
    failureCallback,
    responseType: 'text',
    successCallback
  });

export const preImportOtherRequestTypeRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_request_types/pre_import', {
    dispatch,
    params,
    failureCallback,
    successCallback
  });

export const importOtherRequestTypeRequest = ({ dispatch, params, formData, failureCallback, successCallback }) =>
  ApiService.request('post', '/other_request_types/import', {
    dispatch,
    params,
    formData,
    failureCallback,
    successCallback
  });

export const importTemplateOtherRequestTypeRequest = ({ dispatch, params = {}, failureCallback, successCallback }) =>
  ApiService.request('get', '/other_request_types/import_template', {
    dispatch,
    params,
    responseType: 'text',
    failureCallback,
    successCallback
  });

export const debounceIndexOtherRequestTypeRequest = AwesomeDebouncePromise(indexOtherRequestTypeRequest, 300);